<template>
    <div>
        <Modal v-model="showAfterSale" :mask-closable="false" :closable="false" title="分配售后人员">
            <Form ref="form" :model="form" :rules="rule">
                <FormItem label="售后人员" prop="afterSalePersonId">
                    <Select v-model="form.afterSalePersonId" @on-change="isautside">
                        <Option v-for="(item, index) in PersonList['afterSalePersonList']" :key="index" :value="item.id">{{ item.fullName }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="抄送总经理" prop="managerUserId" v-if="isOutSide">
                    <Select v-model="form.managerUserId">
                        <Option v-for="(item, index) in PersonList['managerList']" :key="index" :value="item.userId">{{ item.name }}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancel" class="close-btn">取消</Button>
                <Button @click="ok" type="primary" class="close-btn">提交</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import { distributionAfterSalePerson } from '../../../api/index';
export default {
    props: {
        showAfterSale: {
            type: Boolean,
            required: true,
            default: false,
        },
        PersonList: {
            type: Object,
            default: { managerList: [], afterSalePersonId: [] },
        },
        guid: {
            type: Array,
            required: true,
        },
        taskId:{
            type:[String,Number],
        }
    },
    data() {
        return {
            form: {
                managerUserId: '',
                afterSalePersonId: '',
            },
            isOutSide: false,
            rule: {
                managerUserId: [{ required: true, message: '请选择', trigger: 'blur', type: 'number' }],
                afterSalePersonId: [{ required: true, message: '请选择', trigger: 'blur', type: 'number' }],
            },
        };
    },
    methods: {
        isautside(e) {
            let _this = this;
            this.PersonList.afterSalePersonList.filter(el => {
                if (el.id == e) {
                    _this.isOutSide = el.isOutSide;
                }
            });
        },
        ok() {
            let _this = this;
            this.$refs['form'].validate(async valid => {
                if (valid) {
                // debugger
                    if (_this.guid.length>0&&_this.taskId) {
                        _this.form.guid = _this.guid[0];
                        _this.form.taskId = _this.taskId;
                        await distributionAfterSalePerson(_this.form);
                        _this.isOutSide = false;
                        //  this.$Message.success('操作成功');
                         this.$Message.success({ content: '操作成功', duration: 5 });
                        this.$refs['form'].resetFields();
                        this.$parent.closeShowAfterSale();
                        this.$parent.getpage();
                    }
                } else {
                }
            });
        },
        cancel() {
            this.$refs['form'].resetFields();
            this.isOutSide = false;
            this.$parent.closeShowAfterSale();
        },
    },
};
</script>
